import {
  AssistantCapabilities,
  AssistantCapabilitiesResponse,
  AssistantEngine,
} from "../type/capabilities";

/** Safe default while capabilities are loading (Autogen / JSON transport). */
export const DEFAULT_ASSISTANT_CAPABILITIES: AssistantCapabilities = {
  engine: "autogen",
  streaming: false,
  hitl: false,
  mq_jobs: false,
};

function parseEngine(raw: unknown): AssistantEngine {
  return raw === "langgraph" ? "langgraph" : "autogen";
}

export function parseAssistantCapabilities(raw: unknown): AssistantCapabilities {
  if (!raw || typeof raw !== "object") {
    return DEFAULT_ASSISTANT_CAPABILITIES;
  }
  const data = raw as AssistantCapabilitiesResponse;
  return {
    engine: parseEngine(data.engine),
    streaming: data.streaming === true,
    hitl: data.hitl === true,
    mq_jobs: data.mq_jobs === true,
  };
}

export function supportsAssistantStream(caps: AssistantCapabilities): boolean {
  return caps.streaming;
}

export function supportsAssistantHitl(caps: AssistantCapabilities): boolean {
  return caps.hitl;
}

export function supportsAssistantMqJobs(caps: AssistantCapabilities): boolean {
  return caps.mq_jobs;
}

/** LangGraph は job-thread の有無に関わらず ``job.completed`` / ``job.error`` SSE を出す。 */
export function supportsAssistantJobEvents(caps: AssistantCapabilities): boolean {
  return caps.engine === "langgraph";
}
